import { GenericHelpers } from '../../utilities/luigi-generic.helper';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  signal,
} from '@angular/core';
import { ButtonComponent } from '@fundamental-ngx/core/button';
import { ContentDensityDirective } from '@fundamental-ngx/core/content-density';
import {
  IllustratedMessageActionsComponent,
  IllustratedMessageComponent,
  IllustratedMessageFigcaptionComponent,
  IllustratedMessageTextDirective,
  IllustratedMessageTitleDirective,
} from '@fundamental-ngx/core/illustrated-message';
import { Context, addInitListener } from '@luigi-project/client/luigi-client';
import { I18nService, LuigiCoreService } from '@openmfp/portal-ui-lib';

@Component({
  selector: 'app-no-plugin-handling',
  imports: [
    IllustratedMessageComponent,
    IllustratedMessageActionsComponent,
    IllustratedMessageFigcaptionComponent,
    IllustratedMessageTitleDirective,
    IllustratedMessageTextDirective,
    ButtonComponent,
    ContentDensityDirective,
  ],
  templateUrl: './no-plugin-handling.component.html',
  styleUrl: './no-plugin-handling.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class NoPluginHandlingComponent implements AfterContentInit {
  readonly config = signal<any>({
    scene: {
      url: 'assets/moments/tnt-Scene-ExternalLink.svg',
      id: 'tnt-Scene-ExternalLink',
    },
    illustratedMessageTitle: '',
    illustratedMessageText: '',
    buttons: [],
  });

  readonly extensionUrl = signal('');
  extensionLabel = '';

  constructor(
    private luigiCoreService: LuigiCoreService,
    private i18nService: I18nService,
  ) {}

  async ngAfterContentInit() {
    this.luigiCoreService.ux().hideAppLoadingIndicator();
    this.i18nService.afterInit();

    addInitListener(async (ctx) => {
      this.extensionLabel = this.replaceInterpolations(ctx.label, ctx);
      this.extensionUrl.set(this.replaceInterpolations(ctx.url, ctx));

      await this.setConfig(
        ctx.isOutdated,
        ctx.currentVersion,
        ctx.requiredVersion,
      );
    });
  }

  goTo(url: string): void {
    window.open(url, '_blank', 'noreferrer');
  }

  replaceInterpolations(value: string, ctx: Context): string {
    return GenericHelpers.replaceVars(value, ctx, 'context.');
  }

  private async setConfig(
    isOutdated: boolean,
    currentVersion: string,
    requiredVersion: string,
  ): Promise<void> {
    this.config.set({
      ...this.config(),
      illustratedMessageTitle: await this.i18nService.getTranslationAsync(
        isOutdated
          ? 'PLUGIN_PAGE_CAN_NOT_BE_SHOWN_UPDATE'
          : 'PLUGIN_PAGE_CAN_NOT_BE_SHOWN',
        { extensionLabel: this.extensionLabel },
      ),
      illustratedMessageText: await this.i18nService.getTranslationAsync(
        isOutdated
          ? 'PLUGIN_PAGE_NEED_EXTENSION_UPDATE'
          : 'PLUGIN_PAGE_OPEN_IN_NEW_TAB',
        { currentVersion, requiredVersion },
      ),
    });
  }
}
